import { counter } from "./counter";

export function scrollAnimate() {
    const _window = this._window;
    const _document = this._document;
    const isDesktop = _document.querySelector("body").classList.contains("no-touch");
    const elements = _document.querySelectorAll(".scrolled");
    const addHeight = _window.innerHeight * 0.6; // optional
    let animateCoords = [];
    let scrolled = _window.scrollY || _window.pageYOffset;

    function detectElements() {
        animateCoords = [];
        [...elements].forEach((item) => {
            let elemProps = item.getBoundingClientRect();
            animateCoords.push({
                top: elemProps.top + scrolled
            });
        });
    }

    function animate() {
        if (isDesktop) {

            scrolled = _window.scrollY || _window.pageYOffset;

            [...animateCoords].forEach((item, index) => {

                if (item.top < (scrolled + addHeight)) {
                    if (!elements[index].classList.contains("animation")) {
                        elements[index].classList.add("animation");
                        setTimeout(() => {
                            elements[index].classList.remove("scrolled");
                        }, 2000);
                        if(elements[index].classList.contains("impact-of-depression")) {
                            counter();
                        }
                    }
                }
            });
        }
    }

    _window.addEventListener("load", () => {
        if (isDesktop) {
            detectElements();
            animate();
        }
    });
    _window.addEventListener("scroll", () => {
        if (isDesktop) {
            animate();
        }
    });
    _window.addEventListener("resize", () => {
        if (isDesktop) {
            detectElements();
            animate();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scroll-animate.js